import { FC, useState } from "react";
import CustomButton from "ui/Button";
import { ICON_NAMES } from "utils/constant";
import { useTranslation } from "react-i18next";
import { AnnualStatementFilter } from "api/accounting";
import CustomDropDownList from "ui/dropDown";
import { Vessel } from "interface/vessel";
import { getVesselFilter } from "api/vessel";

interface CustomProps {
	pageSize: number;
	setFilterOptions: (options: AnnualStatementFilter) => void;
	filterOptions: AnnualStatementFilter;
	exportAsPDF: () => void;
	exportAsExcel: () => void;
}
const Filter: FC<CustomProps> = ({
	setFilterOptions,
	filterOptions,
	...props
}) => {
	const { t } = useTranslation();

	return (
		<div className="filter-container">
			<div className="filter-items annual-statement-filter-items">
				<div className="annual-statement-filter-field" style={{ width: "170px" }}>
					<CustomDropDownList
						data={[]}
						filterable={true}
						dataItemKey="id"
						textField="nm"
						label={t("Vessel")}
						value={{
							id: filterOptions.vesselId || null,
						//	nm: filterOptions.vesselName || t("ChooseVessel"),
							nm: filterOptions.vesselName || " ",
						}}
						// label="Velg Fartøy"
						defaultItem={{ id: null, nm: t("All") }}
						onSelect={(vessel: Vessel) => {
							setFilterOptions({
								...filterOptions,
								vesselId: vessel.id,
								vesselName: vessel.id ? vessel.nm : "",
								vesselLedgerAccountNumber: vessel.res as any,
								take: props.pageSize,
								skip: 0,
							});
						}}
						serverFilter={true}
						serverFilterApi={getVesselFilter}
						// popupSettings={{ width: 400 }}
					/>
				</div>
			</div>

			<div className="filter-end-btn annual-statement-filter-end-btn">
				<CustomButton
					label={"Excel"}
					onClick={() => props.exportAsExcel()}
					iconName={ICON_NAMES.Download}
				/>
			</div>
		</div>
	);
};

export default Filter;
